import React from "react";
import "./assets/css/bootstrap-rtl.css";
import "./assets/css/myStyle.css";
import "./assets/vendor/fontawesome/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import config from "./utils/config";
import ScreenProvider from "./providers/screen/ScreenProvider";
import PrimitiveData from "./components/primitive_data";
import Version from "./components/version";
import Routes from "./routes";

function App() {
  return (
    <PrimitiveData>
      <Version>
        <ToastContainer
          autoClose={config.toastAutoClose}
          hideProgressBar={true}
        />
        <ScreenProvider>
          <Routes />
        </ScreenProvider>
      </Version>
    </PrimitiveData>
  );
}

export default App;
